import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { Check } from 'lucide-react';
import { UrgencyBanner } from './UrgencyBanner';
type Offer = 'kit' | 'mega';
const OFFERS = {
  kit: {
    href: 'https://solucionesya.shop/cart/48819516735736:1',
    cta: 'QUIERO EL KIT NEGOCIO DE ORO'
  },
  mega: {
    href: 'https://solucionesya.shop/cart/48819517128952:1',
    cta: 'SÍ, QUIERO EL MEGAPACK COMPLETO'
  }
};
export function OfferSelector() {
  const [selected, setSelected] = useState<Offer>('mega');
  return <section className="bg-[linear-gradient(180deg,rgba(201,168,76,0.04)_0%,transparent_100%)] py-12 sm:py-20" data-id="element-216">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-217">
        <UrgencyBanner data-id="element-218" />

        <div className="mb-3 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-219">
          Oferta en vivo
        </div>
        <h2 className="mb-2 text-center font-serif text-[clamp(24px,4vw,38px)] font-bold leading-[1.2] text-white" data-id="element-220">
          Elegí tu Negocio de Oro
        </h2>
        <p className="mb-8 text-center text-[14px] text-text" data-id="element-221">
          Ambas opciones incluyen los 3 bonos estratégicos completos
        </p>

        <div className="mx-auto flex max-w-[620px] flex-col gap-3" data-id="element-222">
          {/* KIT */}
          <OptionCard selected={selected === 'kit'} onSelect={() => setSelected('kit')} name="Kit Negocio de Oro" tagline="Tu primera venta en 30 días" price="$19.990" features={['6 Tomos base', '3 Bonos estratégicos', 'Proveedores + Ferias']} data-id="element-223" />
          {/* MEGAPACK */}
          <OptionCard selected={selected === 'mega'} onSelect={() => setSelected('mega')} name="Megapack Negocio de Oro" tagline="El sistema completo con marca propia" price="$27.990" featured features={['Todo el Kit (6 tomos + 3 bonos)', '★ Tomo 7 · Tu marca en redes', '★ Tomo 8 · Clientes que vuelven']} data-id="element-224" />
        </div>

        {/* SHARED CTA */}
        <div className="mx-auto mt-8 max-w-[480px] text-center" data-id="element-225">
          <a href={OFFERS[selected].href} target="_blank" rel="noopener noreferrer" className="block w-full rounded-md bg-gold p-[18px] text-[15px] font-bold tracking-[0.04em] text-[#111] transition-all duration-200 hover:-translate-y-0.5 hover:bg-gold-light" data-id="element-226">
            {OFFERS[selected].cta}
          </a>
          <div className="mt-4 text-[11px] tracking-[0.06em] text-muted" data-id="element-227">
            Pago seguro · Acceso en 5 min · Garantía 7 días · Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}
type OptionCardProps = {
  selected: boolean;
  onSelect: () => void;
  name: string;
  tagline: string;
  price: string;
  features: string[];
  featured?: boolean;
};
function OptionCard({
  selected,
  onSelect,
  name,
  tagline,
  price,
  features,
  featured
}: OptionCardProps) {
  return <button type="button" onClick={onSelect} aria-pressed={selected} className={clsx('relative flex w-full items-center gap-4 rounded-2xl border bg-card p-4 text-left transition-all duration-300 sm:gap-5 sm:p-5', selected ? 'border-gold shadow-[0_0_24px_rgba(201,168,76,0.18)]' : 'border-border hover:border-gold/40')} data-id="element-228">
      {featured && <div className="absolute -top-2.5 left-5 whitespace-nowrap rounded bg-gold px-3 py-1 text-[9px] font-bold uppercase tracking-[0.1em] text-[#111]" data-id="element-229">
          ⭐ Más elegido
        </div>}

      {/* Radio indicator */}
      <span className={clsx('flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-colors', selected ? 'border-gold bg-gold' : 'border-muted')} data-id="element-230">
        {selected && <motion.span initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        duration: 0.2
      }} data-id="element-231">
            <Check className="h-3.5 w-3.5 text-[#111]" strokeWidth={4} data-id="element-232" />
          </motion.span>}
      </span>

      {/* Name + tagline + features */}
      <div className="min-w-0 flex-1" data-id="element-233">
        <div className="text-[15px] font-semibold text-white" data-id="element-234">{name}</div>
        <div className="mb-1.5 text-[12px] italic text-gold" data-id="element-235">{tagline}</div>
        <div className="flex flex-wrap gap-x-3 gap-y-1" data-id="element-236">
          {features.map((f, i) => <span key={i} className="flex items-center gap-1 text-[11px] text-muted" data-id="element-237">
              <Check className="h-3 w-3 shrink-0 text-gold" strokeWidth={3} data-id="element-238" />
              {f}
            </span>)}
        </div>
      </div>

      {/* Price */}
      <div className="shrink-0 text-right font-serif text-[28px] font-black leading-none text-gold sm:text-[34px]" data-id="element-239">
        {price}
      </div>
    </button>;
}